<div>
  <div *ngIf="!this.displayIcon" class="lm-poll-print-status-container-noicon">
    <span data-automation-id="lm-poll-and-print-status" class="lmPollStatusNoIcon">{{this.status}}</span>
  </div>
  <div *ngIf="this.displayIcon" class="lm-poll-print-status-container-icon">
    <svg [ngClass]="svgIconClasses" style="top: 0px !important" focusable="false" aria-hidden="true" role="presentation">
      <use [attr.xlink:href]="'#icon-' + this.iconName"></use>
    </svg>
    <span data-automation-id="lm-poll-and-print-status" class="lmPollStatusIcon">{{this.status}}</span>
  </div>
  <div class="lmPollStatusMessage" ><span data-automation-id="lm-poll-and-print-status-message"  [innerHTML]="statusMessage | safe"></span></div>
</div>
